import React from 'react';
import { buildMonthsMap } from '@features/price-graph';
export const useMonthsPricesMap = (prices) => {
    return React.useMemo(() => buildMonthsMap(prices), [prices]);
};
